'use strict';

import $ from 'jquery';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faFile, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faBars, faSpinner, faLink, faUpRightFromSquare, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faNewspaper, faEnvelope } from '@fortawesome/free-regular-svg-icons';

$(function() {
    $('.link-icon').html(icon(faUpRightFromSquare).html);
    $('.mail-icon').html(icon(faEnvelope).html);
    $('.phone-icon').html(icon(faPhone).html);
    $('.perm-link-icon').html(icon(faLink).html);
    $('.file-icon').html(icon(faFile).html);
    $('.newspaper-icon').html(icon(faNewspaper).html);
    $('.facebook-icon').html(icon(faFacebookSquare).html);
    $('.instagram-icon').html(icon(faInstagram).html);

    $('.fa-bars').html(icon(faBars).html);
    $('.fa-spinner').html(icon(faSpinner).html);
});
